<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Hizmet İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo">Yenile</el-button>
        <el-button size="small" type="default" @click="HizmetEkle" :disabled="lo">Hizmet Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.Adi.toLowerCase().includes(Kelime.toLowerCase()))"
          @current-change="TableSecim"
          :height="Height">
        <el-table-column label="Tanım" prop="Adi" width="400"></el-table-column>
        <el-table-column label="Açıklama" prop="Aciklama"></el-table-column>
        <el-table-column label="Türü" prop="TurText"></el-table-column>
        <el-table-column width="200" align="right" class-name="tablearama">
          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        title="Hizmet Form"
        :visible.sync="HizmetModalDurum"
        :v-loading="lo"
        width="40%"
    >
      <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
               ref="Form">
        <el-row :gutter="24">

          <el-col :span="!Form.Urun?24:12">
            <el-form-item label="Tanım" prop="Adi">
              <el-input v-model="Form.Adi" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="Form.Urun">
            <el-form-item label="Alış" prop="Alis">
              <el-input v-model="Form.Alis" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="Form.Urun">
            <el-form-item label="Satış" prop="Satis">
              <el-input v-model="Form.Satis" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input type="textarea" v-model="Form.Aciklama" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="text-center">
            <el-switch
                v-model="Form.Urun"
                active-text="Ürün"
                inactive-text="Diğer">
            </el-switch>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!lo" size="small" type="danger" @click="HizmetModalDurum=false">İptal</el-button>
        <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  data() {
    return {
      Kelime: '',
      lo: false,
      ModalBaslik: 'Hizmet Ekle',
      HizmetModalDurum: false,
      Liste: [],
      Height: null,
      Duzenle_id: null,
      Form: {
        Adi: '',
        Aciklama: '',
        Urun: false,
        Alis: 0,
        Satis: 0
      },
      FormHata: {
        Adi: [{required: true, message: "Tanım boş bırakılamaz", trigger: 'blur'}]
      },
    }
  },
  methods: {
    HizmetEkle() {
      this.Duzenle_id = null
      this.Form = {
        Adi: '',
        Aciklama: '',
        Urun: false,
        Alis: 0,
        Satis: 0
      }
      this.HizmetModalDurum = true
    },
    TableSecim(e) {
      this.Duzenle_id = e.id
      this.ModalBaslik = e.Adi + ' Düzenle'
      this.Form = {
        Adi: e.Adi,
        Aciklama: e.Aciklama,
        Urun: e.Urun,
        Alis: e.Alis,
        Satis: e.Satis,
      }
      this.HizmetModalDurum = true
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          var Tur = this.Duzenle_id ? 'Put' : 'Post'
          this.$store.dispatch(Tur, {...this.Form, path: 'hizmet/' + this.Duzenle_id})
              .then(response => {
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    },
    SayfaYukle() {
      this.Form = {
        Adi: '',
        Aciklama: '',
        Urun: false
      }
      this.HizmetModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: 'hizmet'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Liste
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    }
  },
  created() {
    this.SayfaYukle()
    this.Height = window.innerHeight - 111
    this.$store.dispatch("title", "Hizmet");
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/Hizmet.vue